require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-discuss-cannabis-map.json") })
        }
      }, "path---projects-discuss-cannabis-map");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-discuss-cannabis-map!./.cache/json/projects-discuss-cannabis-map.json
// module id = 518
// module chunks = 231608221292675